<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Export Marks</span>
        </v-row>
        <br />
        <v-card v-if="allocation_status!=null" class="mx-auto card">
            <center><v-btn color="success" dark class="mb-2" @click="doit('xlsx');" style="margin-top:10px;">
                Export Excel
            </v-btn></center>
            <br>
            <v-card-title class="heading justify-center">
                <span>Export Marks</span>
            </v-card-title>
            <template>
                <div id="exceltable">
                    <table class="borderclass padding" style="width:100%;">
                      <thead>
                        <tr>
                          <th class="borderclass padding">S.N.</th>
                          <th class="borderclass padding">PRN No.</th>
                          <th class="borderclass padding">Roll No.</th>
                          <th class="borderclass padding">Name of Student</th>
                          <th class="borderclass padding"> A/P</th>
                          <th class="borderclass padding">Marks
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in allocation_status" :key="index">
                          <td class="borderclass padding">{{index+1}} </td>
                          <td class="borderclass padding">{{item.prn}}</td>
                          <td class="borderclass padding">{{item.roll}}</td>
                          <td class="borderclass padding">{{item.name}}</td>
                          <td class="borderclass padding">{{item.ispresent}}</td>
                          <td class="borderclass padding">{{item.marks}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
            </template>
        </v-card>
    </div>    
</template>
<script>
  import axios from "axios";
  import * as XLSX from 'xlsx';
  export default {
    data: () => ({
      init_load: false,
      load_allocate: false,
      load_allocate_subject: false,
      //
      snackbar_msg: "",
      color: "",
      snackbar: false,
      course_allocation: null,
      allocation_status: null,
      examtimetableid:"",
      editflag:false,
      course:"",
      division:"",
      exam:"",
      exam_date:"",
      start_time:"",
      end_time:"",
      extratime:null,
      item:"",
      course:null,
    }),
    computed: {
    },
    mounted() {
        this.examtimetableid = this.$route.params.examtimetableid;
        const data = {
            examtimetableid: this.examtimetableid,
        };
        axios
            .post("QuizDashboard/exportMarksBatchWise",data)
            .then((res) => {
                if (res.data.status == "200" && res.data.msg == "success") {
                    if (res.data.course_allocation != "") {
                        this.allocation_status = res.data.course_allocation;
                        this.course = res.data.course;
                    } 
                } 
                else if (res.data.status == "201") {
                        this.allocation_status = "";
                    this.showSnackbar("#b71c1c", "Exam time table not found!!!"); // show snackbar on success
                }
                else if (res.data.status == "203") {
                    this.allocation_status = "";
                    this.showSnackbar("#b71c1c", "Learner Exam Summay Data Not Found"); // show snackbar on success
                } 
                else {
                    this.allocation_status = "";
                    this.showSnackbar("#b71c1c", "Student Marks Data Not Found"); // show snackbar
                }
            })
            .catch((error) => {
                this.showSnackbar("Something Went Wrong...", "#b71c1c");
                this.dialog = false;
            })
            .finally(() => {
                this.dialog = false;
            });
        },
    methods: {
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
      doit(type, fn, dl) {
        var elt = document.getElementById('exceltable');
        var wb = XLSX.utils.table_to_book(elt, {sheet:"Sheet JS", raw:true});
        return dl ?
            XLSX.write(wb, {bookType:type, bookSST:true, type: 'base64'}) :
            XLSX.writeFile(wb, fn || (this.course+'.' + (type || 'xlsx')));
    },
    },
    
  };
  </script>
  <style scoped>
  .downbtn {
    float: right;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
  
  .v-icon-size {
    font-size: 20px;
  }
  
  .edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
  }
  
  .edit-avatar:hover {
    background-color: #b0bec5;
  }
  
  .edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
  }
  
  .edit-v-icon:hover {
    color: white;
  }
  .all-pic {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white;
    }
    .button {
        border: 2px solid hsla(190, 99%, 30%, 1) !important;
        color: rgb(1, 127, 152);
        background: transparent !important;
        border-radius: 50px;
    }
  </style>